import {Button} from '@mui/material';
import {useNavigate} from 'react-router-dom';

import {useAuth} from 'src/components/AuthProvider.tsx';

const Logout = () => {
  const {setToken} = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    setToken(null);
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('userId');
    navigate('/', {replace: true});
  };

  return <Button onClick={handleLogout}>Logout</Button>;
};

export default Logout;
